import styled from 'styled-components'

export const DevelopersArea = styled.main`
    flex: 1;
    width: 100%;
    background: #eef3fb;
    border-radius: 18px;
    padding: 20px;
    min-height: 500px;
    box-shadow: inset 0 0 0 1px #d8e3f2;
`

export const DevelopersList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 18px;
`
